import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isStakeholder } from '../utils/roleUtils';
import Dashboard from './Dashboard';

/** Routes staff dashboard; stakeholders go to portal */
const DashboardHome = () => {
  const { user } = useAuth();
  if (isStakeholder(user)) {
    return <Navigate to="/dashboard/stakeholder" replace />;
  }
  return <Dashboard />;
};

export default DashboardHome;
